import { Container } from "@mui/material";
import React, { useState } from "react";
import Body from "./Body";
import Footer from "./Footer";
import HtmlCenterContainer from "./HtmlCenterContainer";
import HtmlContainer from "./HtmlContainer";
import MainHeader from "./main/MainHeader";
import SideBar from "./main/SideBar";

export default function Layout({
  sidebar = true,
  noHeader = false,
  children = "",
  breadCrumb = [],
  variant = "sidebar",
}) {
  const [openSide, setOpenSide] = useState(false);
  return variant === "sidebar" ? (
    <HtmlContainer>
      {!noHeader && (
        <MainHeader
          breadCrumb={breadCrumb}
          onToggle={() => setOpenSide((s) => !s)}
        />
      )}
      {sidebar && <SideBar open={openSide} />}
      <Body noHeader={noHeader}>{children}</Body>
      <Footer />
    </HtmlContainer>
  ) : variant === "empty" ? (
    <HtmlCenterContainer>
      <Container maxWidth="sm">{children}</Container>
    </HtmlCenterContainer>
  ) : (
    children
  );
}
